import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { EmojiSad } from '@styled-icons/entypo/EmojiSad';
import { ExternalLink } from '@styled-icons/heroicons-solid/ExternalLink';

import { removeTokenGerenciamento } from '../../../../utils/tokencidtechapi';

class LoginExpirado extends React.Component {

    componentDidMount(){
        removeTokenGerenciamento();
    }
    
    render() {
        return (
            <>
            <Alert variant="warning">
            <Alert.Heading><EmojiSad size="2em" /> Você foi deslogado por inatividade</Alert.Heading>
            
            <p style={{cursor: 'pointer'}} onClick={() => {this.props.history.push('/gerenciamento/login')}}>
                Clique aqui para acessar novamente<ExternalLink size="1em"/>
            </p>            
            </Alert>
            </>
        )
    }
}

export default connect(null)(withRouter(LoginExpirado));